"use client";
import { useState, useEffect } from 'react';
import { readStorage, writeStorage } from '@/lib/visitorIdentity';

export function useUrgencyBannerState() {
  // Default visible — this matches the server-rendered output, so the common case (a
  // visitor who hasn't dismissed it) needs no post-hydration flip and causes zero layout
  // shift. Dismissal is the exception, not the rule, so only that case pays for a
  // (much less noticeable) shrink after mount, checked below since localStorage doesn't
  // exist during SSR.
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Mounted in SiteHeader with the trackers: must not throw where storage is blocked.
    const dismissed = readStorage('local', 'urgencyBannerDismissed');
    if (dismissed) {
      const dismissedTime = parseInt(dismissed, 10);
      if (Date.now() - dismissedTime < 24 * 60 * 60 * 1000) {
        setIsVisible(false);
      }
    }
  }, []);

  const dismiss = () => {
    setIsVisible(false);
    writeStorage('local', 'urgencyBannerDismissed', Date.now().toString());
  };

  return { isVisible, dismiss };
}
